export default __webpack_public_path__ + "static/media/logo.efa471df.png";